import { gql } from '__generated__'

export const GetCandidatesForClientPortalSql = gql(/* GraphQL */ `
    query GetCandidatesForClientPortalSql(
        $rosterId: ID
        $referenceRosterIds: [ID!]
        $filters: CandidateSearchFilters
        $page: Int!
        $limit: Int!
        $sort: [CandidateSearchSortInput!]
    ) {
        candidateSearchSql(
            rosterId: $rosterId
            referenceRosterIds: $referenceRosterIds
            filters: $filters
            page: $page
            limit: $limit
            sort: $sort
        ) {
            pageInfo {
                itemTotal
                pageNumber
                pageTotal
            }
            data {
                id
                candidateId
                rosterId
                rosterCandidateId
                rosterCandidateCreatedAt
                rosterCandidateSourceStatus
                rosterCandidateFavoriteCount
                clientFavorites {
                    clientId
                }
                profileImageKey
                internalProfileImageKey
                firstName
                lastName
                nickname
                email
                phone
                gender
                ethnicity
                starRatingAvg
                systemStatus
                recruitingStatus
                linkedinUrl
                visaStatus
                starRatingReference
                starRatingMostRecentScreen
                preferredEmail
                currentLocation
                previousCompany
                currentCompany
                currentCompanyId
                startDate
                previousStartDate
                previousTitle
                currentTitle
                startDates
                currentIndustry
                currentSector
                currentSectorDescription
                previousIndustry
                previousSector
                candidateDocumentId
                candidateDocumentKey
                resumeUpdatedDate
                currentWorkEmail
                mbaEducation
                mbaYear
                undergradYear
                undergradEducation
                undergradGpa
                act
                sat
                gmat
                ccatRawScore
                ccatPercentile
                publicBio
                preAdmitAttribute
                referenceAttribute
                cpiAttribute
                mbaTiering
                recruitingIndustryPref1
                recruitingIndustryPref2
                recruitingIndustryPref3
                recruitingSectorPref1
                recruitingSectorPref2
                recruitingSectorPref3
                recruitingGeoLocationPref1
                recruitingGeoLocationPref2
                recruitingGeoLocationPref3
                rosterCount
                hometown
                analystClassYear
                processStatus
                processStatusSummaryGroup
                rosterInterestFromBlast
                rosterNotInterestedReasonFromBlast
                rosterCommentsFromBlast
                rosterLocationFromBlast
                rosterSectorFromBlast
                rosterCandidate {
                    id
                    candidateProcessStatus {
                        id
                        updatedAt
                        processStatus {
                            id
                            status
                            statusLabel
                            processStatusSummaryGroup {
                                id
                                summaryGroup
                            }
                        }
                    }
                    sourceStatus
                    candidateColors {
                        id
                        rosterColor {
                            id
                            hexCode
                            order
                            updatedAt
                            createdAt
                            value
                        }
                    }
                    mostRecentJobBoardResponse {
                        id
                        officePrefs {
                            companyOffice {
                                officeLocation {
                                    value
                                }
                            }
                        }
                        sectorPrefs {
                            sector {
                                value
                            }
                        }
                    }
                }
                referenceRosterCandidates {
                    rosterId
                    processStatus
                    processStatusLabel
                    summaryGroup
                    summaryGroupLabel
                }
            }
        }
    }
`)
